import classNames from 'classnames'
import { type ReactNode } from 'react'
import { Link } from 'react-router-dom'

const NavItem = ({ children, href, selected = false, icon }: { children: ReactNode, icon: ReactNode, href: string, selected: boolean }) => {
  return (
    <Link
      to={href}
      className="w-full"
    >
      <li
        className={classNames(
          'py-[11px] px-[15px] -mx-[15px] transition-all rounded-lg border font-medium text-sm text-gray-900 flex gap-1.5',
          'hover:bg-gray-300 hover:border-gray-500',
          {
            'border-primary-900': selected,
            'border-transparent': !selected,
          },
        )}
      >
        <span className={selected ? 'text-primary-900' : ''}>
          {icon}
        </span>
        {children}
      </li>
    </Link>
  )
}

export default NavItem
